import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { queryKeys } from '../react-query.config';

export interface CreateFeedQuestionRequest {
  pickemId: string;
  questionType:
    | 'player_selection'
    | 'team_selection'
    | 'player_over_under'
    | 'team_over_under'
    // Main markets (DKPLAT-500)
    | 'moneyline'
    | 'spread'
    | 'total';
  fixtureId: string;
  leagueId?: string; // Optional: Skips expensive fixture lookup if provided
  statTypeCode: string;
  playerIds?: string[];
  teamIds?: string[];
  margin?: number;
  displayOrder?: number;
  points?: number;
}

interface CreateFeedQuestionResponse {
  questionId: string;
  message: string;
}

export const createFeedQuestion = async (
  data: CreateFeedQuestionRequest
): Promise<CreateFeedQuestionResponse> => {
  const response = await api.post('/feed-questions', data);
  return response.data as CreateFeedQuestionResponse;
};

export const useCreateFeedQuestionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createFeedQuestion,
    onSuccess: () => {
      // Invalidate questions list to refetch with new question
      queryClient.invalidateQueries({ queryKey: queryKeys.questions.all });
    },
  });
};
